<br>
<footer  class="blog-footer">
  
  <p>        
        <a style="color: black;"   target="_blank" href="/privacystatement" >
          Privacy Policy   
        </a>|
            
        <a style="color: black;"  target="_blank" href="/termsofuse" >
                Terms of Use  
        </a> |
              
        <a style="color: black;"  target="_blank" href="https://www.carinalliance.com/code-of-conduct" >
              
                Carin Code of Conduct
              
        </a>
               
  </p>              
</footer>
